import { render, staticRenderFns } from "./Dorms.vue?vue&type=template&id=d4352510&scoped=true&"
import script from "./Dorms.vue?vue&type=script&lang=js&"
export * from "./Dorms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4352510",
  null
  
)

export default component.exports